<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="user.verificado"
            depressed
            class="mr-2"
            color="primary lighten-3"
            @click="$router.go(-1)"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-4"
            @click="salvar"
            :loading="loadingSalvar"
            :disabled="!form_valid"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-divider />

        <v-tabs
          ref="tabs"
          left
          v-model="tab_atual"
          background-color="primary"
          slider-color="accent"
          dark
        >
          <v-tab href="#dados">
            <v-icon class="mr-4">mdi-format-list-checkbox</v-icon>Dados
          </v-tab>
          <v-tab href="#logo">
            <v-icon class="mr-4">mdi-image</v-icon>Logo
          </v-tab>
          <v-tab href="#video">
            <v-icon class="mr-4">mdi-television-play</v-icon>Vídeo Showroom
          </v-tab>
          <v-spacer />

          <v-tabs-items v-model="tab_atual">
            <v-tab-item
              value="dados"
              :transition="false"
              :reverse-transition="false"
            >
              <v-form ref="form" lazy-validation v-model="form_valid">
                <v-container fluid class="px-4">
                  <v-row dense v-if="!user.verificado">
                    <v-col cols="12">
                      <v-alert type="error" prominent text>
                        Caro fornecedor, precisamos concluir o seu cadastro
                        <br />Por favor, preencha os dados obrigatórios abaixo e
                        clique em SALVAR para poder prosseguir
                      </v-alert>
                    </v-col>
                  </v-row>
                  <!-- <v-row
                    dense
                    v-if="
                      user.tipo == 'fornecedor' && !user.verificacao_fornecedor
                    "
                  >
                    <v-col cols="12">
                      <v-alert border="left" elevation="3" text type="error"
                        >Antes de continuar, é necessário que o seu cadastro
                        seja completado. Por favor, preencha os campos que estão
                        indicados pela cor vermelha e com o texto 'Campo
                        obrigatório' para poder continuar.
                      </v-alert>
                    </v-col>
                  </v-row> -->
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        ref="razao_social"
                        label="Razão Social"
                        :rules="rulesForm.razao_social"
                        v-model="fornecedor.razao_social"
                        @keydown.native.enter="$refs.nome_fantasia.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        ref="nome_fantasia"
                        label="Nome Fantasia"
                        :rules="rulesForm.nome_fantasia"
                        v-model="fornecedor.nome_fantasia"
                        @keydown.native.enter="$refs.cnpj.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        ref="cnpj"
                        label="CNPJ"
                        :rules="rulesForm.cnpj"
                        v-model="fornecedor.cnpj"
                        v-mask="'##.###.###/####-##'"
                        :return-masked-value="true"
                        @keydown.native.enter="$refs.ie.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        ref="ie"
                        label="Inscrição Estadual"
                        :rules="rulesForm.ie"
                        v-model="fornecedor.ie"
                        @keydown.native.enter="$refs.nome_socio.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        ref="nome_socio"
                        label="Nome Sócio"
                        :rules="rulesForm.nome_socio"
                        v-model="fornecedor.nome_socio"
                        @keydown.native.enter="$refs.cpf.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        ref="cpf"
                        label="CPF"
                        :rules="rulesForm.cpf"
                        v-model="fornecedor.cpf"
                        v-mask="'###.###.###-##'"
                        :return-masked-value="true"
                        @keydown.native.enter="$refs.data_nascimento.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <as-date-picker-menu
                        ref="data_nascimento"
                        label="Data de Nascimento"
                        :rules="rulesForm.data_nascimento"
                        v-model="fornecedor.data_nascimento"
                        @enter="$refs.logradouro.focus()"
                      ></as-date-picker-menu>
                    </v-col>
                  </v-row> -->
                  <v-row dense>
                    <v-col cols="12" sm="7">
                      <v-text-field
                        ref="logradouro"
                        label="Logradouro"
                        :rules="rulesForm.logradouro"
                        v-model="fornecedor.endereco.rua"
                        @keydown.native.enter="$refs.complemento.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        ref="complemento"
                        label="Complemento"
                        v-model="fornecedor.endereco.complemento"
                        @keydown.native.enter="$refs.numero.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        ref="numero"
                        label="Número"
                        :rules="rulesForm.numero"
                        v-model="fornecedor.endereco.numero"
                        @keydown.native.enter="$refs.bairro.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        ref="bairro"
                        label="Bairro"
                        :rules="rulesForm.bairro"
                        v-model="fornecedor.endereco.bairro"
                        @keydown.native.enter="$refs.estado.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select
                        :items="estados"
                        ref="estado"
                        label="Estado"
                        :rules="rulesForm.estado"
                        v-model="fornecedor.endereco.estado_id"
                        @change="onSelectEstado"
                        @keydown.native.enter="$refs.cidade.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-autocomplete
                        :items="cidades"
                        ref="cidade"
                        label="Cidade"
                        :rules="rulesForm.cidade"
                        v-model="fornecedor.endereco.cidade_id"
                        :loading="loadingCidades"
                        @keydown.native.enter="$refs.cep.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        ref="cep"
                        label="CEP"
                        :rules="rulesForm.cep"
                        v-model="fornecedor.endereco.cep"
                        v-mask="'#####-###'"
                        :return-masked-value="true"
                        @keydown.native.enter="$refs.telefone.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        ref="telefone"
                        label="Telefone"
                        :rules="rulesForm.telefone"
                        v-model="fornecedor.endereco.telefone"
                        v-mask="'(##) ####-####'"
                        :return-masked-value="true"
                        @keydown.native.enter="$refs.celular.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        ref="celular"
                        label="Celular"
                        :rules="rulesForm.celular"
                        v-model="fornecedor.endereco.celular"
                        v-mask="'(##) #####-####'"
                        :return-masked-value="true"
                        @keydown.native.enter="$refs.email.focus()"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        ref="email"
                        label="E-mail"
                        :rules="rulesForm.email"
                        v-model="fornecedor.endereco.email"
                        @keydown.native.enter="salvar"
                        :disabled="user.verificado === 1"
                        autocomplete="off"
                        role="presentation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-tab-item>
            <v-tab-item
              value="video"
              class="px-4"
              :transition="false"
              :reverse-transition="false"
            >
              <v-row>
                <v-col sm="4">
                  <as-load-video
                    v-model="video"
                    @onExcluir="video = ''"
                    @onMensagem="exibirMensagem"
                    limiteMaximoDuracao="60"
                  ></as-load-video>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item
              value="logo"
              class="px-4"
              :transition="false"
              :reverse-transition="false"
            >
              <v-row>
                <v-col sm="4">
                  <as-load-video
                    v-model="video"
                    @onExcluir="video = ''"
                    @onMensagem="exibirMensagem"
                    limiteMaximoDuracao="60"
                  ></as-load-video>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>

      <!-- <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Responsável</v-toolbar-title>
        </v-app-bar>
        <v-form ref="formResponsavel" lazy-validation v-model="form_valid">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="8">
                <v-text-field ref="nome" label="Nome" :rules="rulesResponsavel.nome" v-model="responsavel.nome"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  ref="cpf"
                  label="CPF"
                  :rules="rulesResponsavel.cpf"
                  v-model="responsavel.cpf"
                  v-mask="'###.###.###-##'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="7">
                <v-text-field ref="logradouro" label="Logradouro" :rules="rulesResponsavel.logradouro" v-model="responsavel.endereco.rua"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field ref="complemento" label="Complemento" v-model="responsavel.endereco.complemento"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field ref="numero" label="Número" :rules="rulesResponsavel.numero" v-model="responsavel.endereco.numero"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field ref="bairro" label="Bairro" :rules="rulesResponsavel.bairro" v-model="responsavel.endereco.bairro"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  :items="estados"
                  ref="estado"
                  label="Estado"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.estado_id"
                  @change="onSelectEstadoResponsavel"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="5">
                <v-autocomplete
                  :items="cidadesResponsavel"
                  ref="cidade"
                  label="Cidade"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.cidade_id"
                  :loading="loadingCidadesResponsavel"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="cep"
                  label="CEP"
                  :rules="rulesResponsavel.cep"
                  v-model="responsavel.endereco.cep"
                  v-mask="'#####-###'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="telefone"
                  label="Telefone"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.telefone"
                  v-mask="'(##) ####-####'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="celular"
                  label="Celular"
                  :rules="rulesResponsavel.celular"
                  v-model="responsavel.endereco.celular"
                  v-mask="'(##) #####-####'"
                  :return-masked-value="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field ref="email" label="E-mail" :rules="rulesResponsavel.email" v-model="responsavel.endereco.email"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>-->

      <as-dialogo
        ref="dialogoInfoLogin"
        title="Informações para Login"
        max-width="600px"
        hideCloseButton
      >
        <v-label class="text--primary"
          >Seu cadastro foi atualizado com sucesso!</v-label
        >
        <br />
        <br />
        <v-label class="text--primary"
          >A partir de agora, quando for entrar no sistema, você deve utilizar o
          email que você acabou de informar</v-label
        >
        <br />
        <br />
        <v-label class="text--primary">
          Antigo Login
          <br />
          {{ login_antigo }}
        </v-label>
        <br />
        <br />
        <v-label class="text--primary">
          Novo Login
          <br />
          <b>{{ fornecedor.endereco.email }}</b>
        </v-label>
        <br />
        <br />
        <v-label class="text--secondary"
          >Sua senha não foi alterada, você deve continuar usando a
          mesma</v-label
        >
        <br />
        <div class="pt-4" style="display: flex; justify-content: flex-end;">
          <v-btn depressed color="primary" @click="$router.push('/')"
            >Entendi</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="mensagem"
        :title="mensagem.titulo"
        max-width="440px"
        hideCloseButton
      >
        <p>{{ mensagem.texto }}</p>
        <div class="pt-4" style="display: flex; justify-content: flex-end;">
          <v-btn depressed @click="$refs.mensagem.fechar()">Fechar</v-btn>
        </div>
      </as-dialogo>
    </v-container>
    <v-row v-show="loading" class="justify-center align-center mt-5">
      <v-progress-circular
        indeterminate
        size="50"
        width="3"
        color="primary"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceFornecedores from "@/services/fornecedores.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "MinhaContaFornecedor",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      loadingSalvar: false,
      loadingCidades: false,
      loadingCidadesResponsavel: false,
      titulo: "Minha Conta",
      exibirPesquisa: false,
      pesquisa: "",
      form_valid: true,
      fornecedor_id: JSON.parse(localStorage.getItem("user")).fornecedor_id,
      user: {},
      fornecedor: {
        id: "",
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        nome_socio: "",
        cpf: "",
        data_nascimento: "",
        endereco_id: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
          email2: "",
        },
      },
      responsavel: {
        id: "",
        cpf: "",
        nome: "",
        endereco_id: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      rulesForm: {
        razao_social: [(value) => !!value || "Campo obrigatório"],
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        ie: [(value) => !!value || "Campo obrigatório"],

        // nome_socio: [(value) => !!value || "Campo obrigatório"],
        nome_socio: [(value) => true],

        // cpf: [
        //   (value) => !!value || "Campo obrigatório",
        //   (value) => this.validarCPF(value) || "CPF Inválido",
        // ],
        cpf: [(value) => true],

        // data_nascimento: [(value) => !!value || "Campo obrigatório"],
        data_nascimento: [(value) => true],

        logradouro: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        celular: [(value) => !!value || "Campo obrigatório"],
        email: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarEmail(value) || "E-mail inválido",
        ],
      },
      rulesResponsavel: {
        nome: [(value) => !!value || "Campo obrigatório"],
        cpf: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCPF(value) || "CPF Inválido",
        ],
        logradouro: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        celular: [(value) => !!value || "Campo obrigatório"],
        email: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarEmail(value) || "E-mail inválido",
        ],
      },
      cidades: [],
      cidadesResponsavel: [],
      estados: Services.estados(),
      login_antigo: "",
      tab_atual: "dados",
      mensagem: {
        titulo: "",
        texto: "",
      },
      excluindo: false,
      video: "",
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;

        let response = await ServiceFornecedores.index(
          this.$auth.user.fornecedor_id
        );
        this.fornecedor = response.data.fornecedor;
        this.fornecedor.endereco.email2 =
          response.data.fornecedor.endereco.email;
        this.video = response.data.video;
        // this.responsavel = response.data.responsavel;

        await this.onSelectEstado();
        await this.onSelectEstadoResponsavel();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onSelectEstado() {
      try {
        this.loadingCidades = true;
        let response = await Services.cidades(
          this.fornecedor.endereco.estado_id
        );
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCidades = false;
      }
    },
    async onSelectEstadoResponsavel() {
      try {
        this.loadingCidadesResponsavel = true;
        let response = await Services.cidades(
          this.responsavel.endereco.estado_id
        );
        this.cidadesResponsavel = response.data.cidades;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCidadesResponsavel = false;
      }
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.loadingSalvar = true;
          let post = {
            fornecedor: this.fornecedor,
            video: this.video,
            // responsavel: this.responsavel,
          };
          let response = await ServiceFornecedores.salvarConfig(post);
          localStorage.setItem("user", JSON.stringify(response.data.user));

          if (this.fornecedor.novo_cadastro) {
            this.$router.push("/");
          } else {
            if (this.user.verificado) {
              this.$router.push("/");
            } else {
              this.login_antigo = this.user.email;
              localStorage.setItem("user", JSON.stringify(response.data.user));
              if (this.fornecedor.endereco.email != this.login_antigo) {
                this.$refs.dialogoInfoLogin.abrir();
              } else {
                this.$router.push("/");
              }
            }
          }

          this.$eventbus.notificar("Dados da conta salvos com sucesso.");
        } catch (error) {
          console.log(error);
          this.$eventbus.erro(error.response.data.message);
        } finally {
          this.loadingSalvar = false;
        }
      }
    },
    exibirMensagem(mensagem) {
      this.mensagem = mensagem;
      this.$refs.mensagem.abrir();
    },
  },
};
</script>
